<template>
  <div class="paywall-overlay">
    <div class="close-button" @click="$emit('close')">✕</div>

    <div class="paywall-container">
      <div class="plans">

        <div
          v-for="(plan, index) in plans"
          :key="plan.type"
          :class="['plan-card', { selected: selectedIndex === index }]"
          @click="selectedIndex = index"
        >
          <div class="plan-header">
            <h2 class="plan-title">{{ plan.title }}</h2>
            <span class="plan-label">{{ plan.label }}</span>
          </div>

          <p class="plan-price">{{ plan.price }}</p>
          <p class="plan-description">{{ plan.description }}</p>

          <ul class="plan-features">
            <li v-for="(f, i) in plan.features" :key="i">
              <span class="check" :class="`check-${index}`">✔</span> {{ f }}
            </li>
          </ul>

          <button
            class="continue-button"
            :class="{ free: plan.type === PremiumPlanType.free }"
            @click.stop="plan.type !== PremiumPlanType.free && startPayment(plan, index)"
            :disabled="loadingIndex === index || plan.type === PremiumPlanType.free"
          >
          <span v-if="plan.type === PremiumPlanType.free">
            Бесплатно
          </span>

          <span v-else-if="loadingIndex !== index">
            Продолжить
          </span>

          <div v-else class="button-loader">
            <div class="loader-dot"></div>
            <div class="loader-dot"></div>
            <div class="loader-dot"></div>
          </div>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from "vue";

import PremiumService from "../api/PremiumService";
import PremiumPlansFactory, { PremiumPlanType } from "../models/PremiumPlansFactory";

// 🔥 Реальные планы из фабрики
const plans = PremiumPlansFactory.allPlans();
const loadingIndex = ref(null);

// по умолчанию выбираем «Скаут+»
const defaultIndex = plans.findIndex(p => p.type === PremiumPlanType.premiumScout);
const selectedIndex = ref(defaultIndex >= 0 ? defaultIndex : 0);

// 🔥 Правильные ключи — 1 в 1 как на iOS и backend
const planBackendKeys = {
  [PremiumPlanType.premiumScout]: "premium_scout",
  [PremiumPlanType.premiumFullstackHR]: "premium_fullstack_hr"
};

async function startPayment(plan, index) {
  if (plan.type === PremiumPlanType.free) return;

  try {
    loadingIndex.value = index;
    await nextTick();

    const backendKey = planBackendKeys[plan.type];
    const { paymentUrl } = await PremiumService.createPayment(backendKey);

    setTimeout(() => {
      window.location.href = paymentUrl;
    }, 150);

  } catch (e) {
    console.error("❌ Ошибка запуска оплаты", e);
    alert("Не удалось начать оплату. Попробуйте позже.");
    loadingIndex.value = null;
  }
}

</script>

<style scoped>

.paywall-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.paywall-overlay {
  position: fixed;
  inset: 0;
  background: radial-gradient(
    circle at center,
    rgba(40, 40, 70, 0.85) 0%,
    rgba(0, 0, 0, 0.9) 45%,
    rgba(0, 0, 0, 0.95) 70%,
    rgba(0, 0, 0, 0.98) 100%
  );
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.plans {
  display: flex;
  gap: 24px;
  width: 100%;
}

.plan-card {
  flex: 1;
  width: 260px;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(20px);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.plan-card.selected {
  background: linear-gradient(160deg, #2e2eff, #6b00ff);
  border-color: white;
}

.plan-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.plan-title {
  font-size: 20px;
  font-weight: bold;
  color: white;
}

.plan-label {
  font-size: 12px;
  background: white;
  color: #000;
  padding: 2px 8px;
  border-radius: 6px;
  font-weight: 600;
}

.plan-price {
  font-size: 24px;
  font-weight: 600;
  color: white;
  margin: 10px 0;
}

.plan-description {
  font-size: 14px;
  color: #cccccc;
  margin-bottom: 16px;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
  color: white;
  font-size: 14px;
}

.check {
  color: #00ffcc;
  margin-right: 8px;
}

.continue-button {
  background: white;
  color: #000;
  padding: 12px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 44px;
}

.continue-button:hover {
  background: #f0f0f0;
}

.close-button {
  position: absolute;
  top: 32px;
  right: 32px;
  font-size: 24px;
  color: white;
  cursor: pointer;
  z-index: 1000;
  transition: transform 0.2s ease;
}

.close-button:hover {
  transform: scale(1.2);
}

.check {
  margin-right: 8px;
  font-weight: bold;
}

.check-0 {
  color: #3D8BFF;
}

.check-1 {
  color: #7e61ff; 
}

.check-2 {
  color: #d46fff; 
}

.continue-button {
  background: white;
  color: #000;
  padding: 12px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 14px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.continue-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.button-loader {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.loader-dot {
  width: 7px;
  height: 7px;
  background: #000;
  border-radius: 50%;
  animation: dotPulse 1.2s infinite ease-in-out;
}

.loader-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loader-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotPulse {
  0% { transform: scale(1); opacity: 0.6; }
  50% { transform: scale(1.6); opacity: 1; }
  100% { transform: scale(1); opacity: 0.6; }
}

@media (max-width: 768px) {
  .paywall-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .paywall-container {
    width: 100%;
    max-height: 92vh;
    overflow-y: auto;
    padding: 18px 16px calc(24px + env(safe-area-inset-bottom));
    box-sizing: border-box;
    border-radius: 28px 28px 0 0;
    background: rgba(12, 12, 22, 0.92);
    backdrop-filter: blur(24px);
  }

  .plans {
    flex-direction: column;
    gap: 14px;
  }

  .plan-card {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 22px;
  }

  .plan-header {
    gap: 12px;
  }

  .plan-title {
    font-size: 18px;
    margin: 0;
  }

  .plan-label {
    font-size: 10px;
    border-radius: 999px;
    padding: 4px 8px;
  }

  .plan-price {
    font-size: 22px;
    margin: 12px 0 6px;
  }

  .plan-description {
    font-size: 13px;
    line-height: 1.45;
    margin-bottom: 14px;
  }

  .plan-features {
    font-size: 13px;
    line-height: 1.45;
    margin-bottom: 18px;
  }

  .plan-features li {
    margin-bottom: 8px;
  }

  .continue-button {
    width: 100%;
    height: 48px;
    border-radius: 999px;
    font-size: 14px;
  }

  .close-button {
    top: 14px;
    right: 16px;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: rgba(255,255,255,0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
}

.continue-button.free {
  background: rgba(255,255,255,0.12);
  color: rgba(255,255,255,0.7);
  border: 1px solid rgba(255,255,255,0.15);
  cursor: default;
}

.continue-button.free:hover {
  background: rgba(255,255,255,0.12);
}

.continue-button.free:disabled {
  opacity: 1;
}

</style>